import { Option } from '@sapphire/result';

import {
  TAG_LABEL_MAX_LENGTH,
  TAG_NAME_DUPLICATE_MESSAGE,
  TAG_NAME_REQUIRED_MESSAGE,
  TAG_NAME_TOO_LONG_MESSAGE,
} from '../constants/tag-create.constants';

export function tagNameValidationError(
  name: string,
  existingLabels: readonly string[],
): Option<string> {
  const trimmedName = name.trim();

  if (!trimmedName) {
    return Option.some(TAG_NAME_REQUIRED_MESSAGE);
  }

  if (trimmedName.length > TAG_LABEL_MAX_LENGTH) {
    return Option.some(TAG_NAME_TOO_LONG_MESSAGE);
  }

  const isDuplicate = existingLabels.some(
    (label) => label.trim().toLowerCase() === trimmedName.toLowerCase(),
  );

  return isDuplicate ? Option.some(TAG_NAME_DUPLICATE_MESSAGE) : Option.none;
}
